import {combineReducers} from 'redux'
import types from 'actions/types'

export const sites = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_SITES_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_SITES_FAILURE:
      return []
    default:
      return state
  }
}

export const baseSite = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_BASE_SITE_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_BASE_SITE_FAILURE:
      return null
    default:
      return state
  }
}

export const isBaseSiteSet = (state = false, action) => {
  switch (action.type) {
    case types.DOCUMENTS_UPDATE_BASE_SITE_SUCCESS:
      return true
    case types.DOCUMENTS_UPDATE_BASE_SITE_FAILURE:
      return false
    default:
      return state
  }
}

export const drives = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_DRIVES_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_DRIVES_FAILURE:
      return []
    default:
      return state
  }
}

export const baseDrive = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_BASE_DRIVE_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_BASE_DRIVE_FAILURE:
      return null
    default:
      return state
  }
}

export const isBaseDriveSet = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_UPDATE_BASE_DRIVE_SUCCESS:
      return action.data
    case types.DOCUMENTS_UPDATE_BASE_DRIVE_FAILURE:
      return null
    default:
      return state
  }
}

export const isLoadingFolders = (state = false, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_FOLDERS_BY_ID_ATTEMPT:
      return true
    case types.DOCUMENTS_LOAD_FOLDERS_BY_ID_SUCCESS:
    case types.DOCUMENTS_LOAD_FOLDERS_BY_ID_FAILURE:
      return false
    default:
      return state
  }
}

export const folders = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_FOLDERS_BY_ID_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_FOLDERS_BY_ID_FAILURE:
      return []
    default:
      return state
  }
}

export const isBaseFolderSet = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_IS_BASE_FOLDER_SET_SUCCESS:
    case types.DOCUMENTS_UPDATE_BASE_FOLDER_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_IS_BASE_FOLDER_SET_FAILURE:
    case types.DOCUMENTS_UPDATE_BASE_FOLDER_FAILURE:
      return null
    default:
      return state
  }
}

export const baseFolder = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_BASE_FOLDER_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_BASE_FOLDER_FAILURE:
      return null
    default:
      return state
  }
}

export const uploadUrl = (state = null, action) => {
  switch (action.type) {
    case types.DOCUMENTS_LOAD_UPLOAD_URL_SUCCESS:
      return action.data
    case types.DOCUMENTS_LOAD_UPLOAD_URL_FAILURE:
      return null
    default:
      return state
  }
}

export default combineReducers({
  baseDrive,
  baseFolder,
  baseSite,
  drives,
  folders,
  isBaseDriveSet,
  isBaseFolderSet,
  isBaseSiteSet,
  isLoadingFolders,
  sites,
  uploadUrl,
})
